import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/bluehero.webp';
import screenshot_target from '../../../images/letterfunnel/christiaanmolendijk.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Christiaan Molendijk"
      firstname="Christiaan"
      companyname="BlueHero"
      competition="Temper en YoungOnes"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/christiaanmolendijk.js